import { get, post, put } from "./api_helper"
import * as url from "./url_helper"

// me
export const getInfoMeAPI = () => get(url.GET_INFO_ME)

// users
export const getUsersAPI = params => get(url.GET_USERS, params)
export const getUsersByIdAPI = id => get(`${url.GET_USERS_BY_ID}/${id}`)
export const getUsersAuthorAPI = () => get(url.GET_AUTHOR)
export const getUsersCraftsmanAPI = () => get(url.GET_CRAFTSMAN)
export const postUsersAPI = data => post(url.ADD_USERS, data)
export const putUsersAPI = (data, id) =>
  put(`${url.GET_USERS_BY_ID}/${id}`, data)
